<template>
    <section class="products-viewed" v-if="items">
        <DefTitle :result="2">
            <h2>
                {{ messages.title }}
            </h2>
        </DefTitle>
        <!--        :nav="screenWidth >= 992"-->
        <DefSlider
                :nav="true"
                :pagination="true"
                :settings="settings"
                ref="slider"
        >
            <div
                    v-for="item in items"
                    :key="item.offer && item.offer.id || item.id"
                    class="swiper-slide"
            >
                <SliderCard :result="item" />
            </div>
        </DefSlider>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import DefTitle from "../../../Def/DefTitle/DefTitle.vue";
    import DefSlider from "../../../Def/DefSlider/DefSlider.vue";
    import SliderCard from "../../../card/SliderCard/SliderCard.vue";
    export default {
        name: "ProductsViewed",
      components: {SliderCard, DefSlider, DefTitle},
        selector: '.products-viewed',
        data() {
          return {
            settings: {
              slidesPerView: 2,
              spaceBetween: 0,
              autoplay: {
                delay: 5000,
              },
              pagination: {
                el: null, // Явно указываем, что пагинация отсутствует
              },
              breakpoints: {
                992: {
                  slidesPerView: 4,
                  spaceBetween: 0,
                  autoplay: false,
                },
              }
            },
          }
        },
        computed: {
            ...mapState({
                items: ({ results }) => results?.viewedProducts?.items,
                messages: ({ results }) => results?.viewedProducts?.messages,
            }),
        },
    }
</script>

<style lang="scss" scoped>
     .product-page.products-viewed .def-title {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 23px;
        h2 {
          color: #333;
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          text-transform: uppercase;
          border: none;
          background-color: transparent;
          padding: 0 40px;
          cursor: pointer;
          transition: color .2s linear;
        }
     }
    .products-viewed{
      :deep(.def-slider__container){
        margin-left: auto;
        margin-right: auto;
      }
      :deep(.def-slider__prev){
        left: 0px;
      }
      :deep(.def-slider__next){
        right: 0px;
      }
      :deep(.slider-card){
        border: 1px solid #f5efef;
      }
      :deep(.def-h2){
        font-size: rem(30);
        margin-left: 3%;
      }
      :deep(.def-link){
        text-decoration-line: blink;
      }
      ::v-deep{
        .slider-card {
          @include point-lg{
            border-top: 1px solid #e0dbd5;
            border-right: 1px solid #e0dbd5;
            border-bottom: 1px solid #e0dbd5;
            height: 100%;
          }
        }
        @media (max-width: 992px) {
          .slider-card {
            border: none;
          }
          .def-slider__next{
            right: 0;
          }
          .def-slider__prev{
            left: 0;
          }
        }
      }
    }
</style>